module.exports = __webpack_public_path__ + "img/header-memoireRingsGold@2x.152d465.jpg";